import { render } from "./messageDialog.vue?vue&type=template&id=04dac14e&scoped=true&ts=true"
import script from "./messageDialog.vue?vue&type=script&lang=ts"
export * from "./messageDialog.vue?vue&type=script&lang=ts"

import "./messageDialog.vue?vue&type=style&index=0&id=04dac14e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dac14e"]])

export default __exports__